import { useQuery } from "@tanstack/react-query";
import { journalsQueries } from "@/entities/journal";

export const useModalInfo = (itemNoVersionId?: string) => {
  return useQuery(
    journalsQueries.getSectionThreeItem({
      itemNoVersionId: itemNoVersionId || "",
    }),
  );
};
